export default function RestaurantWeeksScan(){
    return(
        <img src='scan-restaurant-weeks-fall.jpg' style={{maxWidth:'100%'}} />
    )
}